import React from "react";

function Header() {
  return (
    <div>
      <h1
        className="text-3xl  font-semibold text-center
        py-[20px] shadow-lg"
      >
        CODEHELP BLOGS
      </h1>
    </div>
  );
}

export default Header;
